(function () {
    'use strict';
    realmCommerceApp.directive("phoneValidation", PhoneValidation);
    function PhoneValidation() {
        var directive = {
            link: link,
            restrict: 'A',
            require: 'ngModel',
        };
        return directive;
        function link(scope, elem, attr, ngModel) {
            var validator = function (value) {
                var phone_rgx = /^[(]{0,1}[0-9]{3}[)\.\- ]{0,1}[0-9]{3}[\.\- ]{0,1}[0-9]{4}$/;
                if (phone_rgx.test(value)) {
                    ngModel.$setValidity('phone', true);
                    elem[0].setCustomValidity('');
                    return value;
                } else {
                    ngModel.$setValidity('phone', false);
                    elem[0].setCustomValidity('Incorrect Phone Number.');
                    return undefined;
                }
            };
            ngModel.$parsers.unshift(validator);
            ngModel.$formatters.unshift(validator);
        }
    }
})();


// WEBPACK FOOTER //
// ./static/js/app/components/phonevalidation.directive.js